import { PriceTypeSelect } from 'features/cost-report/components/PriceTypeSelect';
import { useCostReportContext } from 'features/cost-report/hooks/useCostReportContext';

export const CostReportPriceTypeSelect = () => {
  const { priceType, updatePriceType } = useCostReportContext();

  return (
    <PriceTypeSelect priceType={priceType} updatePriceType={updatePriceType} />
  );
};
